module.exports = __webpack_public_path__ + "img/close_ico_1.e3f01b7d.svg";